(function () {
  'use strict';

  function fold(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es');
  }

  function words(value) {
    return fold(value).replace(/['\u2018\u2019\u02bc]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(function (word) {
      return word && word !== 'and' && word !== 'y';
    });
  }

  function normalize(value) {
    return words(value).join('');
  }

  function literal(value) {
    return String(value || '').trim().toLocaleLowerCase('es').replace(/\s+/g, ' ');
  }

  function distance(left, right, limit) {
    if (Math.abs(left.length - right.length) > limit) return limit + 1;
    var previousPrevious;
    var previous = Array.from({ length: right.length + 1 }, function (_, index) { return index; });
    for (var i = 1; i <= left.length; i += 1) {
      var current = [i];
      var rowMinimum = i;
      for (var j = 1; j <= right.length; j += 1) {
        var cost = left[i - 1] === right[j - 1] ? 0 : 1;
        current[j] = Math.min(current[j - 1] + 1, previous[j] + 1, previous[j - 1] + cost);
        if (i > 1 && j > 1 && left[i - 1] === right[j - 2] && left[i - 2] === right[j - 1]) {
          current[j] = Math.min(current[j], previousPrevious[j - 2] + 1);
        }
        rowMinimum = Math.min(rowMinimum, current[j]);
      }
      if (rowMinimum > limit) return limit + 1;
      previousPrevious = previous;
      previous = current;
    }
    return previous[right.length];
  }

  var index = [];
  var headingText = 'Marcas';
  var sequence = 0;
  var bound = new WeakSet();
  var brandAliases = {
    '/collections/pet-ag': ['PetAG', 'Pet AG', 'Cat-Sip', 'Cat Sip', 'Catsip'],
    '/collections/fresh-n-clean': ['Fresh n Clean', 'Fresh and Clean', 'Fresh & Clean', 'FreshnClean'],
    '/collections/n-d': ['ND', 'N D', 'N and D', 'N y D'],
    '/collections/dr-clauder': ['Dr Clauder', 'Dr Clauders', 'Dr. Clauder', 'Dr. Clauders', 'Dr Clauder’s']
  };

  function match(query, rows) {
    var compact = normalize(query);
    var queryWords = words(query);
    var queryLiteral = literal(query);
    if (!compact) return [];
    var candidates = (Array.isArray(rows) ? rows : index).filter(function (row) {
      return row && typeof row.title === 'string' && typeof row.url === 'string' && normalize(row.title);
    }).map(function (row, position) {
      var names = [row.title].concat(brandAliases[row.url] || [], Array.isArray(row.aliases) ? row.aliases : []);
      var titles = names.map(normalize);
      var score = Infinity;
      if (literal(row.title) === queryLiteral) score = 0;
      else if (titles.some(function (title) { return title === compact; })) score = 1;
      else if (compact.length >= 2 && titles.some(function (title) { return title.indexOf(compact) === 0; })) score = 2;
      else if (compact.length >= 3 && names.some(function (name) {
        var titleWords = words(name);
        return queryWords.every(function (queryWord) {
          return titleWords.some(function (titleWord) { return titleWord.indexOf(queryWord) === 0; });
        });
      })) score = 3;
      return { row: row, titles: titles, score: score, position: position };
    });
    var found = candidates.filter(function (candidate) { return candidate.score !== Infinity; });
    if (!found.length && compact.length >= 5) {
      var limit = compact.length >= 9 ? 2 : 1;
      found = candidates.filter(function (candidate) {
        var editDistance = Math.min.apply(null, candidate.titles.map(function (title) {
          return title.length < 5 ? limit + 1 : distance(compact, title, limit);
        }));
        if (editDistance > limit) return false;
        candidate.score = 4 + editDistance;
        return true;
      });
    }
    found.sort(function (left, right) { return left.score - right.score || left.position - right.position; });
    return found.map(function (candidate) { return candidate.row; });
  }

  window.PetProBrandSearch = { match: match, normalize: normalize };

  function urlKey(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/collections\//.test(url.pathname)) return '';
      return url.pathname.replace(/\/$/, '') + url.search;
    } catch (_) { return ''; }
  }

  function uniqueRows(rows, existing) {
    var seen = existing || new Set();
    return rows.filter(function (row) {
      var key = urlKey(row.url);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function linkFor(row, predictive) {
    var link = document.createElement('a');
    link.setAttribute('href', row.url);
    link.className = predictive ? 'predictive-search__item link' : 'petpro-brand-search__link';
    if (predictive) link.setAttribute('tabindex', '-1');
    var label = document.createElement('span');
    label.className = predictive ? 'predictive-search__item-heading predictive-search__item_link' : '';
    label.textContent = row.title;
    link.appendChild(label);
    return link;
  }

  function announce(element, input, countNode, count, original) {
    var text = count ? count + (count === 1 ? ' marca encontrada' : ' marcas encontradas') : '';
    if (countNode) {
      var nativeItems = element.querySelectorAll('[data-predictive-search] li:not([data-petpro-brand-option])').length;
      var combined = count ? (nativeItems && original ? original.trim() + ', ' + text : text) : original;
      if (countNode.textContent !== combined) countNode.textContent = combined;
      text = combined;
    }
    if (document.activeElement !== input || !text) return;
    var status = element.querySelector('.predictive-search-status');
    if (status) {
      status.setAttribute('aria-hidden', 'false');
      status.textContent = text;
    }
  }

  function bindPredictive(element) {
    if (bound.has(element)) return;
    var input = element.querySelector('input[type="search"]');
    var container = element.querySelector('[data-predictive-search]');
    if (!input || !container) return;
    bound.add(element);
    sequence += 1;
    var prefix = 'petpro-brand-search-' + sequence;
    var countTexts = new WeakMap();
    var queued = false;
    var observer = new MutationObserver(schedule);

    function paint() {
      var prior = container.querySelector('[data-petpro-brand-suggestions]');
      var selected = prior && prior.querySelector('[aria-selected="true"] a');
      var selectedUrl = selected ? urlKey(selected.getAttribute('href')) : '';
      if (prior) prior.remove();
      var existing = new Set();
      container.querySelectorAll('a[href]').forEach(function (link) { existing.add(urlKey(link.getAttribute('href'))); });
      var matches = uniqueRows(match(input.value), existing).slice(0, 8);
      var countNode = container.querySelector('[data-predictive-search-live-region-count-value]');
      if (countNode && !countTexts.has(countNode)) countTexts.set(countNode, countNode.textContent);
      if (!matches.length) {
        if (selectedUrl) input.setAttribute('aria-activedescendant', '');
        announce(element, input, countNode, 0, countNode ? countTexts.get(countNode) : '');
        if (!input.value.trim() && typeof element.close === 'function') element.close(true);
        return;
      }
      var section = document.createElement('div');
      section.setAttribute('data-petpro-brand-suggestions', '');
      section.className = 'petpro-brand-search';
      var heading = document.createElement('h2');
      heading.id = prefix + '-heading';
      heading.className = 'predictive-search__heading h5';
      heading.textContent = headingText;
      var list = document.createElement('ul');
      list.className = 'predictive-search__results-list unstyle-ul body2';
      list.setAttribute('role', 'group');
      list.setAttribute('aria-labelledby', heading.id);
      matches.forEach(function (row, position) {
        var item = document.createElement('li');
        item.id = prefix + '-option-' + position;
        item.className = 'predictive-search__list-item';
        item.setAttribute('data-petpro-brand-option', '');
        item.setAttribute('role', 'option');
        var restoreSelection = selectedUrl && selectedUrl === urlKey(row.url);
        item.setAttribute('aria-selected', restoreSelection ? 'true' : 'false');
        if (restoreSelection) input.setAttribute('aria-activedescendant', item.id);
        item.appendChild(linkFor(row, true));
        list.appendChild(item);
      });
      if (selectedUrl && !list.querySelector('[aria-selected="true"]')) input.setAttribute('aria-activedescendant', '');
      section.appendChild(heading);
      section.appendChild(list);
      var nativeResults = container.querySelector('#predictive-search-results');
      (nativeResults || container).prepend(section);
      announce(element, input, countNode, matches.length, countNode ? countTexts.get(countNode) : '');
      if (document.activeElement === input) {
        element.statusElement = element.statusElement || element.querySelector('.predictive-search-status');
        element.setAttribute('results', 'true');
        if (typeof element.open === 'function') element.open();
        else {
          element.setAttribute('open', 'true');
          input.setAttribute('aria-expanded', 'true');
        }
      }
    }

    function schedule() {
      if (queued) return;
      queued = true;
      queueMicrotask(function () {
        queued = false;
        observer.disconnect();
        try { paint(); }
        finally { observer.observe(container, { childList: true, subtree: true }); }
      });
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', schedule);
    observer.observe(container, { childList: true, subtree: true });
    schedule();
  }

  function renderPage() {
    var query = new URLSearchParams(window.location.search).get('q') || '';
    document.querySelectorAll('[data-petpro-brand-search-results]').forEach(function (container, position) {
      var matches = uniqueRows(match(query));
      container.textContent = '';
      container.hidden = !matches.length;
      if (!matches.length) return;
      var heading = document.createElement('h2');
      heading.id = 'petpro-brand-search-page-' + position;
      heading.className = 'h3';
      heading.textContent = headingText;
      var list = document.createElement('ul');
      list.className = 'petpro-brand-search__list unstyle-ul';
      list.setAttribute('aria-labelledby', heading.id);
      matches.forEach(function (row) {
        var item = document.createElement('li');
        item.appendChild(linkFor(row, false));
        list.appendChild(item);
      });
      container.appendChild(heading);
      container.appendChild(list);
      document.querySelectorAll('[data-petpro-search-no-products]').forEach(function (message) {
        message.hidden = true;
      });
    });
  }

  function init() {
    index = [];
    document.querySelectorAll('script[data-petpro-brand-search-index]').forEach(function (script) {
      try {
        if (script.dataset.heading) headingText = script.dataset.heading;
        var rows = JSON.parse(script.textContent);
        if (Array.isArray(rows)) index = index.concat(rows);
      } catch (_) { /* A malformed optional index must not prevent product search. */ }
    });
    document.querySelectorAll('predictive-search').forEach(bindPredictive);
    renderPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
